import Text from '@atoms/Text';
import { idleFunction } from '@helpers/miscelleanous';
import Button from '@ui/atoms/design-system/Button';

const ResultMessage = ({
    primaryMessage,
    secondaryMessage,
    amount,
    isProductPage = false,
    handleOnClick = idleFunction,
    buttonText = null
}) => {
    return (
        <div className="flex justify-center items-center w-full bg-secondary-50 rounded-xl p-3 md:px-8 md:py-4">
            <div
                className={`flex flex-col w-full ${
                    isProductPage ? '' : 'items-center'
                } gap-1 md:gap-2 bg-secondary-50 rounded-xl`}
            >
                <Text
                    content={primaryMessage}
                    className={`text-gray-600 p5-regular md:h4-regular ${
                        isProductPage ? '' : 'text-center'
                    }`}
                    isInnerHtml
                />
                <Text
                    content={amount}
                    className={`text-primary-500 h4-semibold ${
                        isProductPage ? '' : 'text-center'
                    } md:hidden`}
                />
                <Text
                    content={secondaryMessage}
                    className={`text-gray-900 p5-regular ${
                        isProductPage ? '' : 'text-center'
                    }`}
                />
            </div>
            {isProductPage && buttonText ? (
                <Button
                    onClick={handleOnClick}
                    buttonSize="large"
                    buttonText={buttonText}
                />
            ) : null}
        </div>
    );
};

export default ResultMessage;
